<template>
  <div class="i-field-boolean">
    <q-toggle v-on="$listeners" v-bind="computedAttrs" />
  </div>
</template>
<script>
export default {
  props: {
    trueLabel: String,
    falseLabel: String,
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasValue () {
      return this.value !== null && this.value !== undefined
    },
    computedAttrs () {
      return Object.assign({
        // 'checked-icon': 'check',
        // 'unchecked-icon': 'clear',
        // color: 'red',
        label: this.value ? this.trueLabel : this.falseLabel,
        size: 'lg'
      }, this.$attrs, this.$props)
    }
  }
}
</script>
<style lang="scss">
.i-field-boolean {
  padding: 1em 0;
  display: flex;
  justify-content: flex-start;
}
</style>
